import Action from '../Action';
import InspectionOrderService from '../../services/InspectionOrderService';
import { message } from 'antd';

export function fetchInspectionOrders() {
	return (dispatch) => {
		InspectionOrderService.getInspectionOrders()
			.then((inspectionOrders) =>
				dispatch({ type: Action.FETCH_INSPECTION_ORDERS, inspectionOrders: inspectionOrders.data })
			)
			.catch((error) => message.error('Failed to fetch Inspection orders!'));
	};
}

export function addInspectionOrder(body) {
	return (dispatch) => {
		InspectionOrderService.add(body)
			.then((order) => {
				dispatch({ type: Action.POST_INSPECTION_ORDERS });
				message.success('Inspection Order added');
			})
			.catch((error) => message.error('Failed to add Inspection Order!'));
	};
}

export function updateInspectionOrder(id, body) {
	return (dispatch) => {
		InspectionOrderService.update(id, body)
			.then((orders) => {
				dispatch({ type: Action.UPDATE_INSPECTION_ORDERS, inspectionOrder: orders.data });
				message.success('Inspection Order Updated');
			})
			.catch((error) => message.error('Failed to edit Inspection order!'));
	};
}

export function deleteInspectionOrder(id) {
	return (dispatch) => {
		InspectionOrderService.delete(id)
			.then((orders) => {
				dispatch({ type: Action.DELETE_INSPECTION_ORDERS, inspectionOrder: orders.data });
				message.success('Inspection Order Deleted');
			})
			.catch((error) => message.error('Failed to delete order!'));
	};
}
